import React, { Component } from 'react';
import '../settings.css';
import TagsByInput from '../../TagsAndChips/TagsByInput';
import ImageGalleryField from '../../../ImageGalleryField';
import { showNotification } from '../../../StatusNotification';

export class BlogSettings extends Component {
    static displayName = BlogSettings.name;

    constructor(props) {
        super(props);
        this.state = {
            blogConfiguration: null,
            removedTags: []
        };
        this.onTypeTagRemoval = this.onTypeTagRemoval.bind(this);
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newBlogConfiguration = this.state.blogConfiguration;
        newBlogConfiguration[e.target.name] = e.target.value;
        this.setState({ blogConfiguration: newBlogConfiguration });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let blogConfiguration = this.state.blogConfiguration;

        fetch('AdminSettings/UpdateBlogSettingsData', {
            method: 'POST',
            body: JSON.stringify(blogConfiguration),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (data === "Saved") {
                    if (this.state.removedTags.length > 0) {
                        let removedTags = this.state.removedTags;
                        for (var i = 0; i < removedTags.length; i++) {
                            let tag = removedTags[i];
                            fetch('AdminBlog/RemoveBlogTypeReference?typeToRemove=' + tag, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }
                            });
                        }
                    }

                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        )
    }

    async onTypeTagRemoval(tag) {
        let removedTags = this.state.removedTags;
        removedTags.push(tag);
        this.setState({ removedTags: removedTags });
    }

    render() {
        let types;
        let defaultImage;

        let isBlogConfigurationSet = false;
        if (this.state.blogConfiguration != null) {
            let blogConfiguration = this.state.blogConfiguration;
            types = blogConfiguration.types;
            defaultImage = blogConfiguration.defaultImage;

            isBlogConfigurationSet = true;
        }

        let typesInput = isBlogConfigurationSet ?
            <TagsByInput
                tags={types}
                tagUpdate={this.handleChange}
                name='types'
                isRequired={true}
                allowDuplicates={false}
                inputType='text'
                onTagRemoval={this.onTypeTagRemoval}
            /> : "";

        return (
            <div className='admin-settings--form'>
                <form onSubmit={this.handleSubmit}>
                    <div className='grid-wrapper'>
                        <div className='dual-grid--offset'>
                            <div className='dual-grid__1-2 form-title'>
                                <h3>Blog</h3>
                            </div>

                            <label>Default Image: </label>
                            <input name='defaultImage' type='text' defaultValue={defaultImage} onChange={this.handleChange} required hidden />
                            <ImageGalleryField name='defaultImage' currentImageUrl={defaultImage} handleImageChange={this.handleChange} />

                            <label>Types: </label>
                            {typesInput}

                            <div className='dual-grid__1-2'>
                                <button type='submit' className='form-button'>Save</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    async getComponentData() {
        const response = await fetch('AdminSettings/GetBlogSettingsData', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            blogConfiguration: data
        });
    }
}

export default BlogSettings;
